import http from "../utils/http";

export function getWlList(params) {
    return http({
        method: "post",
        url: "/system/sysWhitelist/paging",
        params
    });
}

export function addwlList(params) {
    return http({
        method: "post",
        url: "/system/sysWhitelist/add",
        data: params
    });
}

export function editwlList(params) {
    return http({
        method: "post",
        url: "/system/sysWhitelist/update",
        data: params
    });
}


export function downloadExcel() {
    return http({
        method: "get",
        url:"/system/sysWhitelist/whitelistTemplate/find"
    });
}

export function fileExport() {
    return http({
        method: "get",
        url:"/system/sysWhitelist/exportWhitelist"
    });
}

export function delData(params) {
    return http({
        method: "post",
        url: "/system/sysWhitelist/delete",
        data: params
    });
}
export function uploadFile(params) {
    return http({
        method: "post",
        url: "/system/sysWhitelist/importWhitelist",
        data:params
    });
}
